// extracted by mini-css-extract-plugin
export default {"SearchBlock":"companies-table_SearchBlock__Osi7V"};